import request from '@/plugins/request';

/**
 * @description DIY模板列表
 * @param {Object} param data {Object} 传值参数
 */
export function diyList (data) {
    return request({
        url: '/store/diy/list',
        method: 'get',
        params: data
    });
}

/**
 * @description 保存DIY数据
 * @param {Object} param data {Object} 传值参数
 */
export function diySave (data) {
    return request({
        url: '/store/diy/save',
        method: 'post',
        data
    });
}

/**
 * @description 获取DIY数据
 * @param {Object} param data {Object} 传值参数
 */
export function diyGetInfo (data) {
    return request({
        url: '/store/diy/detail',
        method: 'get',
        params: data
    });
}

/**
 * @description 删除DIY数据
 * @param {Object} param data {Object} 传值参数
 */
export function diyDel (data) {
    return request({
        url: '/store/diy/delete',
        method: 'post',
        data
    });
}

/**
 * @description 页面链接-获取链接；
 */
export function getLink (id) {
    return request({
        url: `/store/diy/getLink`,
        method: 'get'
    });
}

export function categoryList (data) {
    return request({
        url: '/store/data/getCategoryTreeStore',
        method: 'post',
        data
    });
}

export function helpList (data) {
    return request({
        url: '/channel/content.help/list',
        method: 'post',
        data
    });
}
